module.exports = __webpack_public_path__ + "assets/a8242e32d72e21bd576be28d090d8945.png";